import dynamic from 'next/dynamic';
export { DynamicElement } from './dynamic-element';
export const DynamicElementComponent = dynamic(() => import('./dynamic-element'));